var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusThick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "plus-thick-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg plus-thick",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plus-thick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75,12.52H19.39V2.25A2.27,2.27,0,0,0,17.1,0H14.8a2.27,2.27,0,0,0-2.29,2.29V12.52H2.25A2.27,2.27,0,0,0,0,14.81V17.1a2.27,2.27,0,0,0,2.3,2.29H12.51V29.75A2.27,2.27,0,0,0,14.8,32h2.3a2.27,2.27,0,0,0,2.29-2.29V19.48H29.66A2.26,2.26,0,0,0,32,17.19V14.9A2.22,2.22,0,0,0,29.75,12.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusThick);
export default __webpack_public_path__ + "static/media/plus-thick.3db4b0d065a5810fc743ee76b7b107cf.svg";
export { ForwardRef as ReactComponent };